export const WtoTab = {
  ROUTE_TABLE: 'route-table',
  ROUTE_DETAILS: 'route-details',
  ROUTE_RULES: 'route-rules'
} as const;
export type WtoTabType = (typeof WtoTab)[keyof typeof WtoTab];
